module.exports = __webpack_public_path__ + "static/media/top.03776983.png";